<template>
<!--<div class="sidebar__balance" :class="{'sidebar__balance&#45;&#45;active': isOpen}">-->
<!--    <button class="sidebar__balance-title" @click="toggle">-->
<!--        <span class="sidebar__balance-text">Остаток по счету:</span>-->
<!--        <span class="sidebar__balance-amount">{{ balance }} ₽</span>-->
<!--    </button>-->
<!--    <ul v-if="isOpen" class="sidebar__balance-list">-->
<!--        <li v-for="account in accounts" :key="account.id" class="sidebar__balance-item">-->
<!--            <a :href="`/account/${account.id}?date_account_start=01.01.${(new Date()).getFullYear()}`" class="sidebar__balance-link">-->
<!--                <span class="sidebar__balance-date">-->
<!--                    {{ account.primary ? 'Основной счет ' : '' }}{{ getFormattedDate(account.last_updated) }}-->
<!--                </span>-->
<!--                <span class="sidebar__balance-account">-->
<!--                    №{{ account.number }}-->
<!--                </span>-->
<!--                <span class="sidebar__balance-price" :class="{'sidebar__balance-price&#45;&#45;loss': account.balance <= 0}">-->
<!--                    {{ getFormattedBalance(account.balance) }} ₽-->
<!--                </span>-->
<!--            </a>-->
<!--        </li>-->
<!--    </ul>-->
<!--</div>-->
</template>

<script>
import numeral from "numeral";
import ru from "numeral/locales/ru";
import moment from "moment";

export default {
  props: ["balance", "accounts"],

  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },

    getFormattedBalance(balance) {
      numeral.locale("ru");
      return numeral(parseFloat(balance)).format("0,0.00");
    },

    getFormattedDate(date, format='DD.MM.YYYY, HH:mm') {
        return moment(date).format(format);
    }
  }
};
</script>

